import React from 'react';
import { Box, Modal, Card, CardContent, Typography, Button, Stack } from '@mui/joy';
import { VideoCall, Upload } from '@mui/icons-material';

interface VideoApplicationModalProps {
  open: boolean;
  onClose: () => void;
  onRecordNow: () => void;
  onUploadFromDevice: () => void;
  companyName: string;
  positionName: string;
}

const VideoApplicationModal: React.FC<VideoApplicationModalProps> = ({
  open,
  onClose,
  onRecordNow,
  onUploadFromDevice,
  companyName,
  positionName
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2
      }}
    >
      <Card
        sx={{
          maxWidth: 500,
          width: '100%',
          bgcolor: 'white',
          borderRadius: '16px',
          p: { xs: 4, md: 4 },
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          border: 'none'
        }}
      >
        <CardContent sx={{ p: 0 }}>
          <Typography
            level="h3"
            sx={{
              fontSize: { xs: '1.5rem', md: '1.875rem' },
              fontWeight: 600,
              color: '#1A1B1D',
              mb: 2,
              textAlign: 'center'
            }}
          >
            Submit
          </Typography>
          
          <Typography
            level="body-lg"
            sx={{
              fontSize: { xs: '1rem', md: '1.125rem' },
              color: '#7B7F85',
              mb: 4,
              textAlign: 'center'
            }}
          >
            Choose how you'd like to submit your video for {positionName} at {companyName}
          </Typography>

          <Stack spacing={2}>
            <Button
              variant="solid"
              size="lg"
              startDecorator={<VideoCall sx={{ fontSize: 20 }} />}
              onClick={onRecordNow}
              sx={{
                bgcolor: '#2E2D7E',
                color: 'white',
                py: 2,
                fontSize: '1.125rem',
                fontWeight: 600,
                borderRadius: '12px',
                '&:hover': {
                  bgcolor: '#1a1a5e',
                }
              }}
            >
              Record Now
            </Button>

            <Button
              variant="outlined"
              size="lg"
              startDecorator={<Upload sx={{ fontSize: 20 }} />}
              onClick={onUploadFromDevice}
              sx={{
                borderColor: '#2E2D7E',
                color: '#2E2D7E',
                py: 2,
                fontSize: '1.125rem',
                fontWeight: 600,
                borderRadius: '12px',
                '&:hover': {
                  borderColor: '#1a1a5e',
                  color: '#1a1a5e',
                  bgcolor: 'rgba(46, 45, 126, 0.04)',
                }
              }}
            >
              Upload from Device
            </Button>
          </Stack>

          <Button
            variant="plain"
            onClick={onClose}
            sx={{
              mt: 3,
              width: '100%',
              color: '#7B7F85',
              fontSize: '1rem',
              '&:hover': {
                backgroundColor: 'transparent',
                color: '#1A1B1D'
              }
            }}
          >
            Cancel
          </Button>
        </CardContent>
      </Card>
    </Modal>
  );
};

export default VideoApplicationModal; 